module.exports = __webpack_public_path__ + "static/desktop/img/facebook-logo.a9a7c691.png";